import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { LinearProgress, Snackbar } from '@mui/material';
import { BasicFlex } from '../Common';
import * as React from 'react';

const Bar = styled(LinearProgress)`
  flex-grow: 1;
`;

const Alert = styled.div`
  width: 100%;
  background-color: ${props => props.theme.colors.primaryFaint};
  border-radius: 3px;
  padding: 1.5rem 2rem;
  color: ${props => props.theme.colors.primary};
  font-weight: 500;
  box-shadow: 0 3px 5px 0 rgba(0,0,0,.12);
`;


const UploadProgress = ({ progress = 50, isLoading, use }) => {

   const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (
    event,
    reason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    if (isLoading && use) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isLoading, use]);

  return (
    
      <Snackbar 
        open={open} 
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{width: "50%"}}
      >
       <Alert>
        <BasicFlex dir="column" align="center" gap="1rem">
          <BasicFlex gap="2rem" width="100%">
            <Bar variant="determinate" value={progress} />
            <div>{`${progress}%`}</div>
          </BasicFlex>
          <div>
            {progress < 100 ? "Uploading Files..." : "Processing..."}
          </div>
        </BasicFlex>
        </Alert>
      </Snackbar>
  )
};

export default UploadProgress;